export const Rupee = '₹';
